// PROTOTYPE-ONLY — remove before production
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { PROTOTYPE_ROUTES } from "../data/mockData";
import { ChevronDown, ChevronUp, LayoutGrid } from "lucide-react";
import PrototypeBadge from "./PrototypeBadge";

export default function PrototypeNav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <div
      data-testid="prototype-nav"
      className="fixed bottom-4 right-4 z-50 max-w-[300px]"
    >
      <div className="sb-card overflow-hidden">
        <button
          data-testid="prototype-nav-toggle"
          onClick={() => setOpen((v) => !v)}
          className="w-full flex items-center justify-between px-4 py-3 text-left"
        >
          <span className="flex items-center gap-2">
            <LayoutGrid size={16} className="text-[#FFC107]" />
            <span className="text-xs font-bold uppercase tracking-wider">
              Nav
            </span>
            <PrototypeBadge />
          </span>
          {open ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
        </button>
        {open && (
          <div className="max-h-[60vh] overflow-y-auto border-t border-[#2A2F34] sb-scroll">
            {PROTOTYPE_ROUTES.map((r) => {
              const active = pathname === r.path || (r.path !== "/" && pathname.startsWith(r.path));
              return (
                <Link
                  key={r.path}
                  to={r.path}
                  data-testid={`proto-link-${r.path.replace(/[/:]/g, "-")}`}
                  className={`block px-4 py-2 text-[12px] border-b border-[#2A2F34]/60 transition-colors ${
                    active
                      ? "text-[#FFC107] bg-[#FFC107]/5"
                      : "text-[#A1A1AA] hover:text-white hover:bg-white/5"
                  }`}
                >
                  <span className="font-mono text-[10px] text-[#52525b] block">
                    {r.path}
                  </span>
                  {r.label}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
